import * as tslib_1 from "tslib";
import { JobSource, JobState, } from '@models';
import { JobService } from '@services';
import { JobTriggerBaseComponent } from './job-trigger-base.component';
var JobTriggerJobComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobTriggerJobComponent, _super);
    function JobTriggerJobComponent(_jobService) {
        var _this = _super.call(this) || this;
        _this._jobService = _jobService;
        _this.JobState = JobState;
        _this.JobSource = JobSource;
        _this._fetchItem = function () { return _this._jobService.getInstance(_this._itemId, ['Robot', 'Release']); };
        return _this;
    }
    return JobTriggerJobComponent;
}(JobTriggerBaseComponent));
export { JobTriggerJobComponent };
